import axios from 'axios';
import router from '@/router';

export const eLearning = {
	state() {
		return {
			courses: '',
			learningLoader: false,

			selectedVideo: '',
			test: false,
			showQuizModal: '',
			quizTypeModal: '',
			quizTime: '',
			// quiz
			questionQuiz: 0,
			quizQuestions: '',
			selectedAnswer: '',
			allAnswers: [],
			watchedMovieId: '',
			//
			videoAllows: true,
			//
			isTestAllow: false,
			testMessage: '',
			//
			testResult: '',

			learningModal: false,
			cookieYTModal: false,
			confirmExit: false,
			changePath: false,

			path: '',
			isLeaving: false,
			timeIsOverModal: false,

			userGuid: null,

			//wybrany przez uzytkownika film podczas ogladania inengo
			temporaryVideo: {},
		};
	},
	getters: {
		getLearning: (state) => state.learning,
		getDone: (state) => state.done,
		getSelectedVideo: (state) => state.selectedVideo,
		// getTest: state => state.test,
		getShowQuizModal: (state) => state.showQuizModal,
		getQuizTypeModal: (state) => state.quizTypeModal,
		getCourses: (state) => state.courses,
		getQuestionQuiz: (state) => state.questionQuiz,
		getQuizQuestions: (state) => state.quizQuestions,
		getSelectedAnswer: (state) => state.selectedAnswer,
		getAllAnswers: (state) => state.allAnswers,
		getVideoAllows: (state) => state.videoAllows,
		getIsTestAllow: (state) => state.isTestAllow,
		getTestMessage: (state) => state.testMessage,
		getQuizTime: (state) => state.quizTime,

		getTestResult: (state) => state.testResult,

		getLearningModal: (state) => state.learningModal,
		getCookieYTModal: (state) => state.cookieYTModal,

		getConfirmExit: (state) => state.confirmExit,
		getChangePath: (state) => state.changePath,

		getPath: (state) => state.path,
		getIsLeaving: (state) => state.isLeaving,

		getTimeIsOverModal: (state) => state.timeIsOverModal,
		getUserGuid: (state) => state.userGuid,

		getTemporaryVideo: (state) => state.temporaryVideo,
		getLearningLoader: (state) => state.learningLoader,
	},
	mutations: {
		setSelectedVideo: (state, data) => (state.selectedVideo = data),
		// setTest: (state, value) => state.test = value,
		setShowQuizModal: (state, value) => (state.showQuizModal = value),
		setQuizTypeModal: (state, value) => (state.quizTypeModal = value),
		setCourses: (state, data) => (state.courses = data),
		setQuestionQuiz: (state, value) => (state.questionQuiz = value),
		setQuizQuestions: (state, data) => (state.quizQuestions = data),
		setLearningLoader: (state, value) => (state.learningLoader = value),
		setSelectedAnswer: (state, value) => (state.selectedAnswer = value),
		setAllAnswers: (state, data) => state.allAnswers.push(data),
		clearAllAnswers: (state) => (state.allAnswers = []),

		setWatchedMovieId: (state, value) => (state.watchedMovieId = value),
		setVideoAllows: (state, value) => (state.videoAllows = value),
		setIsTestAllow: (state, value) => (state.isTestAllow = value),
		setTestMessage: (state, value) => (state.testMessage = value),
		setQuizTime: (state, value) => (state.quizTime = value),

		setTestResult: (state, value) => (state.testResult = value),
		setPass: (state, value) => (state.pass = value),

		setLearningModal: (state, value) => (state.learningModal = value),
		setCookieYTModal: (state, value) => (state.cookieYTModal = value),
		setConfirmExit: (state, value) => (state.confirmExit = value),
		setChangePath: (state, value) => (state.changePath = value),

		setPath: (state, value) => (state.path = value),
		setIsLeaving: (state, value) => (state.isLeaving = value),

		setTimeIsOverModal: (state, value) => (state.timeIsOverModal = value),

		setUserGuid: (state, value) => (state.userGuid = value),
		setTemporaryVideo: (state, data) => (state.temporaryVideo = data),
	},
	actions: {
		fetchCourses({ commit }) {
			commit('setLearningLoader', true);
			axios
				.get('section/getsectionlist/')
				.then((response) => {
					commit('setCourses', response.data);
					let storeVideo = sessionStorage.getItem('video');
					let selectedObj = {
						id: response.data[0].id,
						name: response.data[0].name,
						movieName: response.data[0].movies[0].name,
						movieSrc: response.data[0].movies[0].src,
					};
					let selected = storeVideo
						? JSON.parse(storeVideo)
						: selectedObj;

					commit('setSelectedVideo', selected);
					commit('setLearningLoader', false);
				})

				.catch(() => {
					commit('setLearningLoader', false);
				})
				.finally(() => {
					commit('setLearningLoader', false);
				});
		},

		generateToken({ state, commit }) {
			commit('setLearningLoader', true);
			let obj = { movieId: state.selectedVideo.movieId };
			axios
				.post('movie/GenerateToken', obj)
				.then((response) => {
					commit('setLearningLoader', false);
					commit('setUserGuid', response.data);
				})
				.catch(() => {
					commit('setLearningLoader', false);
				})
				.finally(() => {
					commit('setLearningLoader', false);
				});
		},

		doneToken({ commit, state }) {
			commit('setLearningLoader', true);
			let obj = { token: state.userGuid };
			axios
				.post('movie/DoneToken', obj)
				.catch(() => {
					commit('setLearningLoader', false);
				})
				.finally(() => {
					commit('setLearningLoader', false);
				});
		},

		generateTokenQuiz({ commit }) {
			axios
				.post('ClientTest/GenerateToken', null)
				.then((response) => {
					commit('setLearningLoader', false);
					commit('setUserGuid', response.data);
				})
				.catch(() => {
					commit('setLearningLoader', false);
				})
				.finally(() => {
					commit('setLearningLoader', false);
				});
		},

		fetchQuizTime({ commit, dispatch }) {
			axios
				.get('ClientTest/GetTestLength')
				.then((response) => {
					commit('setLearningLoader', false);
					commit('setQuizTime', response.data.length);
					dispatch('generateTokenQuiz');
					dispatch('fetchQuiz');
				})
				.catch(() => {
					commit('setLearningLoader', false);
				})
				.finally(() => {
					commit('setLearningLoader', false);
				});
		},

		fetchQuiz({ commit, dispatch, getters, state }) {
			axios
				.get('clientTest/getRandom')
				.then((response) => {
					if (response.data.available) {
						commit('setQuizQuestions', response.data.questions);
						commit('setLearningLoader', false);
						commit('setIsTestAllow', true);
						let msTime = state.quizTime * 600000;
						const now = new Date();
						const expirationDate = new Date(
							now.getTime() + getters.getTimeToLogout
						);
						sessionStorage.setItem(
							'expirationDate',
							expirationDate
						);
						dispatch('fetchLogOutTimer', msTime);

						commit('setLearningModal', false);
						commit('setChangePath', true);
						router.push('/eLearningTest');
					} else {
						commit('setIsTestAllow', false);
						commit('setTestMessage', response.data.message);
					}
				})
				.catch(() => {
					commit('setLearningLoader', false);
				})
				.finally(() => {
					commit('setLearningLoader', false);
				});
		},

		sendAnwsers({ state, commit }) {
			let obj = { questions: state.allAnswers, token: state.userGuid };
			axios
				.post('ClientTest/ClientTestCreate', obj)
				.then((response) => {
					commit('setTestResult', response.data);
					commit('setLearningModal', false);
					commit('setChangePath', true);
					router.push('/eLearningResult');
				})
				.catch(() => {});
		},
	},
};
